import { render } from "./Designer.vue?vue&type=template&id=2b4c2a5b&scoped=true"
import script from "./Designer.vue?vue&type=script&lang=js"
export * from "./Designer.vue?vue&type=script&lang=js"

import "./Designer.vue?vue&type=style&index=0&id=2b4c2a5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4c2a5b"]])

export default __exports__